import { policyTypes } from '@ourbranch/policy-types';
import { standaloneRentersStates, statesEligibleForBranchPlusMPD } from '@ourbranch/lookups';

export const getCoveragesDiscount = (coverages, type) => {
  return coverages
    ? coverages.reduce((discount, c) => {
        return c.type === type ? discount + c.amount : discount;
      }, 0)
    : 0;
};

export const summedPolicyDiscountIDs = ['future_effective_date_savings'];

export const getOptionIfNotBundle = (selectedOption, { autoOption, homeOption, rentersOption, condoOption }, store) => {
  if (selectedOption.includes(policyTypes.Auto)) {
    return autoOption;
  }
  if (selectedOption.includes(policyTypes.Home)) {
    return homeOption;
  }
  if (selectedOption.includes(policyTypes.Condo)) {
    return condoOption;
  }
  if (selectedOption.includes(policyTypes.Renters) && standaloneRentersStates[store.state]) {
    return rentersOption;
  }
  return null;
};
